import { createAction, props } from '@ngrx/store';
import { ResponseCreateProduct, RequestCreateProduct } from '../../shared/interfaces';
import { CreateProductTypes } from '../../shared/enums';


export const getCreateProduct = createAction(
    CreateProductTypes.CREATEPRODUCT,
    props<{ request: RequestCreateProduct}>()
);

export const getCreateProductSucess = createAction(
    CreateProductTypes.CREATEPRODUCT_SUCCESS,
    props<{ response: ResponseCreateProduct }>()
);

export const getCreateProductError = createAction(
    CreateProductTypes.CREATEPRODUCT_ERROR,
    props<{ payload: any }>()
);

export const cleanState = createAction(
    CreateProductTypes.CLEAN_STATE
);
